import { datadogLogs } from '@datadog/browser-logs';
import { NODE_ENV } from '@/constants/environment';

/**
 * Client-side error logger. Forwards to Datadog Browser Logs when the SDK has
 * been initialized, and mirrors to the console in non-production so errors stay
 * visible during local development and before Datadog init.
 *
 * Use this instead of a bare `console.error` in client components/hooks.
 * Server-side code (route handlers, auth, proxy) should keep using
 * `console.error` since the browser Datadog SDK is not available there.
 */
export function logError(
  message: string,
  error?: unknown,
  context?: Record<string, unknown>,
): void {
  let normalizedError: Error | undefined;
  if (error instanceof Error) {
    normalizedError = error;
  } else if (error != null) {
    normalizedError = new Error(String(error));
  } else {
    normalizedError = undefined;
  }

  if (typeof window !== 'undefined' && datadogLogs.getInitConfiguration()) {
    datadogLogs.logger.error(message, context, normalizedError);
  }

  if (process.env.NODE_ENV !== NODE_ENV.PRODUCTION) {
    console.error(message, error);
  }
}
